if (!customElements.get('custom-related-products')) {
  class CustomRelatedProducts extends HTMLElement {
    constructor() {
      super();
      this._swiperContainer = null;
      this._swiperInstance = null;
      this.columnsDesktop = this.getAttribute("data-columns-desktop") ?? 4;
      // Reload swiper when recommendations loaded.
      this.addEventListener("product-recommendations:loaded", () => {
        this._swiperContainer = this.querySelector('.swiper');
        this.initializeSwiper();
      });

      this.ajaxProducts = this.querySelector('[data-render-releated-products]');
      this.ajaxQuickview = this.querySelector('[data-render-releated-quickview]');

      this.productId = this.getAttribute('data-priority-product-id')
        ?? window.localStorage.getItem('history_product_id')
        ?? this.getAttribute('data-spare-product-id');

      if (this.productId) {
        // has product id
        const findAjaxProducts = document.querySelector('[data-ajax-releated-products]');
        const findAjaxQuickview = document.querySelector('[data-ajax-releated-quickview]');

        if (findAjaxProducts?.innerHTML?.trim().length && findAjaxQuickview?.innerHTML?.trim().length) {
          this.renderRecommendations(document);
        } else {
          this.loadRecommendations(this.productId);
        }
      } else {
        // no product id
        this.classList.add('hidden');
      }
    }

    connectedCallback() {
      requestAnimationFrame(() => {
        this._swiperContainer = this.querySelector('.swiper');
        this.initializeSwiper();
      });
    }

    initializeSwiper() {
      this._swiperContainer = this.querySelector('.swiper');
      if (!this._swiperContainer) {
        console.error('Swiper container not found');
        return;
      }

      const nextButton = this.querySelector('.custom-related-products__navigation .swiper-btn-next');
      const prevButton = this.querySelector('.custom-related-products__navigation .swiper-btn-prev');
      const pagination = this.querySelector(`.custom-related-products__pagination .swiper-pagination`);

      this._swiperInstance = new Swiper(this._swiperContainer, {
        slidesPerGroup: 1,
        slidesPerView: 1.1,
        spaceBetween: 16,
        loop: false,
        direction: "horizontal",
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          300: {
            slidesPerGroup: 1,
            slidesPerView: 1.3,
            spaceBetween: 16,
          },
          350: {
            slidesPerGroup: 1,
            slidesPerView: 1.5,
            spaceBetween: 16,
          },
          375: {
            slidesPerGroup: 1,
            slidesPerView: 1.6,
            spaceBetween: 16,
          },
          590: {
            slidesPerGroup: 1,
            slidesPerView: 2.4,
            spaceBetween: 16,
          },
          769: {
            slidesPerGroup: 1,
            slidesPerView: 2.3,
            spaceBetween: 24,
          },
          990: {
            slidesPerGroup: 3,
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1200: {
            slidesPerGroup: 4,
            slidesPerView: 4,
            spaceBetween: 24,
          },
          1400: {
            slidesPerGroup: this.columnsDesktop,
            slidesPerView: this.columnsDesktop,
            spaceBetween: 32,
          },
        }
      });
    }

    renderRecommendations(htmlElememt) {
      const html = htmlElememt;
      const ajaxProducts = html.querySelector('[data-ajax-releated-products]');
      const ajaxQuickview = html.querySelector('[data-ajax-releated-quickview]');

      if (ajaxProducts?.innerHTML.trim().length) {
        this.ajaxProducts.innerHTML = ajaxProducts.innerHTML;
      }

      if (ajaxQuickview?.innerHTML.trim().length) {
        this.ajaxQuickview.innerHTML = ajaxQuickview.innerHTML;
      }

      if (html.querySelector('.grid__item')) {
        this.classList.add('product-recommendations--loaded');
      }
    }

    // Get recommendations from main-product section.
    async loadRecommendations(productId) {
      return fetch(`${this.dataset.url}&product_id=${productId}&section_id=main-product`)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          this.renderRecommendations(html);
        })
        .catch((e) => {
          console.error(e);
        }).finally(() => {
          this.dispatchEvent(new CustomEvent('product-recommendations:loaded', { bubbles: true }));
          this.initializeSwiper();
        });
    }
  }

  customElements.define('custom-related-products', CustomRelatedProducts);
}